import { type FC, type ReactNode } from 'react';
import { FocusTrap } from '@george-labs.com/design-system';

import style from './FocusPageOverlay.module.scss';

interface Props {
    active: boolean;
    children: ReactNode;
    'data-cy'?: string;
}

export const FocusPageOverlay: FC<Props> = ({ active, children, 'data-cy': dataCy }) => {
    return (
        <FocusTrap
            active={active}
            tag="div"
            className={style.wrapper}
            data-cy={dataCy}
            role="dialog"
            aria-modal="true"
        >
            {children}
        </FocusTrap>
    );
};
